import React from "react";
import PropTypes from "prop-types";

//
import ScrollBar from "react-perfect-scrollbar";

//
import { Dropdown } from "react-bootstrap";

function FilterDropdown({
  title,
  icon,
  filters,
  activeFilter,
  action,
  fit = false,
  full = false,
  align = "end",
}) {
  return (
    <Dropdown className="ms-auto" align={align}>
      <Dropdown.Toggle className={full ? "full" : ""}>
        {icon && <i className={icon}></i>}

        {title && <span className="title">{title} :</span>}
        {activeFilter.name ? (
          <span>{activeFilter.name}</span>
        ) : (
          <span className="text-muted">Select one</span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className={fit ? "fit" : ""}>
        <ScrollBar>
          {filters.map((item, index) => (
            <Dropdown.Item key={index} onClick={() => action(item)}>
              {item.name}
            </Dropdown.Item>
          ))}
        </ScrollBar>
      </Dropdown.Menu>
    </Dropdown>
  );
}

FilterDropdown.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  filters: PropTypes.array.isRequired,
  activeFilter: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  fit: PropTypes.bool,
  full: PropTypes.bool,
  align: PropTypes.string,
};

export default FilterDropdown;
